import styles from './styles.module.css';

type ProgressBarProps = {
  percentComplete?: number;
};

/**
 * Returns a progress bar element for the Onboarding header.
 * @param percentComplete - *Optional* - Only shows values between 0 and 100, inclusive. Defaults to 0.
 * @returns JSX.Element
 */
const ProgressBar = ({
  percentComplete = 0,
}: ProgressBarProps): JSX.Element => {
  return (
    <div
      className={styles.barContainer}
      aria-label={`Percent Complete: ${percentComplete}%}`}
    >
      <progress value={percentComplete} max="100" />
    </div>
  );
};

export default ProgressBar;
